<template>
  <div class="event-modal-catalog-example" v-click-outside="hide">
    <button
      class="event-modal-catalog-example__label"
      @click.prevent="isContentShown ? hide() : show()"
    >
      <template v-if="!explicitLabel">
        <template v-if="label">
          <template v-if="locale === 'en'">
            Example
          </template>
          <template v-else>
            <slot name="label">Пример в каталоге</slot>
          </template>
        </template>
      </template>

      <template v-else>
        {{ explicitLabel }}
      </template>

      <span ref="infobutton"><icon name="info"/></span>
    </button>

    <transition name="fade">
      <div
        class="event-modal-catalog-example__content"
        v-if="isContentShown"
        ref="content"
        :style="{ '--arrow-position': arrowPosition }"
      >
        <div
          class="event-modal-catalog-example__content-header"
          v-if="images.length >= 2"
        >
          <div>{{ currentImageIndex + 1 }} / {{ images.length }}</div>

          <div class="event-modal-catalog-example__content-header-nav">
            <button
              class="button-clean event-modal-catalog-example__content-header-nav-item _prev"
              :disabled="!canGoPrev"
              @click.prevent="goPrev"
            >
              <icon name="slide-button-active" v-if="canGoPrev" />
              <icon name="slide-button-noactive" v-else />
            </button>

            <button
              class="button-clean event-modal-catalog-example__content-header-nav-item"
              :disabled="!canGoNext"
              @click.prevent="goNext"
            >
              <icon name="slide-button-active" v-if="canGoNext" />
              <icon name="slide-button-noactive" v-else />
            </button>
          </div>
        </div>

        <div class="event-modal-catalog-example__content-holder">
          <a
            v-if="currentImageSource"
            :href="currentImageSource"
            target="_target"
          >
            <img :src="currentImageSource" alt="" />
          </a>

          <img
            src="/public/static/images/event-no-company-image.svg"
            alt=""
            v-else
            width="100"
            height="100"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { i18n } from "@v2/shared/config";

export default {
  name: "EventModalCatalogExample",

  props: {
    label: {
      type: Boolean,
      default: true
    },

    explicitLabel: {
      type: String,
      default: ""
    },

    images: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    isContentShown: false,
    currentImageIndex: 0,

    arrowPosition: 0
  }),

  computed: {
    locale() {
      return i18n.locale;
    },

    currentImageSource() {
      if (!this.images.length) {
        return null;
      }

      return this.images[this.currentImageIndex];
    },

    canGoPrev() {
      return this.currentImageIndex > 0;
    },

    canGoNext() {
      return this.currentImageIndex + 1 < this.images.length;
    }
  },

  methods: {
    hide() {
      this.isContentShown = false;
    },

    show() {
      this.isContentShown = true;

      this.$nextTick(() => {
        this.calculateArrowPosition();
      });
    },

    goPrev() {
      if (!this.canGoPrev) {
        return;
      }

      this.currentImageIndex--;
    },

    goNext() {
      if (!this.canGoNext) {
        return;
      }

      this.currentImageIndex++;
    },

    calculateArrowPosition() {
      const { content, infobutton } = this.$refs;

      this.arrowPosition = Math.abs(
        content.getBoundingClientRect().right -
          infobutton.getBoundingClientRect().right
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-modal-catalog-example {
  position: relative;

  display: inline-block;

  &__label {
    @include button-clean();

    font-size: 12px;
    font-weight: 500;

    color: #a3a8b3;

    display: flex;
    align-items: center;
    @include respond-down(md) {
      font-size: 0;
    }

    .svg-icon {
      flex-shrink: 0;

      width: 16px;
      height: 16px;

      margin-left: 6.5px;
    }
  }

  &__content {
    padding: 24px;
    border-radius: 2px;
    background: #f0f5f9;

    position: absolute;
    top: calc(100% + 10px);
    right: -10px;

    z-index: 51;

    cursor: default;

    // позиция язычка справа
    --arrow-position: 0;

    // язычок
    &::after {
      content: "";

      display: block;

      width: 0;
      height: 0;

      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid #f0f5f9;

      position: absolute;
      top: 0;
      right: calc(var(--arrow-position) * 1px);

      transform: translateY(-100%);
    }

    &-header {
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      color: #6d7179;

      display: flex;
      align-items: center;
      justify-content: space-between;

      margin-bottom: 24px;

      > * {
        flex-shrink: 0;
      }

      &-nav {
        display: flex;

        margin-left: auto;
        padding-left: 30px;

        &-item {
          &._prev {
            margin-right: 8px;

            .svg-icon {
              transform: rotate(180deg);
            }
          }
        }

        .svg-icon {
          width: 40px;
          height: 40px;
        }
      }
    }

    &-holder {
      width: 300px;
      height: 250px;

      max-width: 100vw;
      max-height: 100vw;

      display: flex;
      justify-content: center;

      a {
        display: flex;

        max-width: 100%;
        max-height: 100%;
      }

      img {
        max-width: 100%;
        max-height: 100%;

        object-fit: contain;

        margin: auto;
      }
    }
  }

  &._center &__content {
    right: 50%;
    top: auto;
    bottom: 30px;

    transform: translateX(50%);

    &::after {
      top: auto;
      bottom: -7px;
      right: 50%;
      transform: translateX(50%) rotate(180deg);
    }
  }
}
</style>
